import { InvokeCallback, Sender } from "xstate";
import { buildUsersApiWithToken } from "@rentablo/api/apiv1";
import i18next from "i18next";
import { getMyAuthorizationWithToken } from "@api";
import { Settings2FAContext } from "../types/Settings2FAContext";
import { Settings2FAEvent } from "../types/Settings2FAEvent";

const queryApi = async (callback: Sender<Settings2FAEvent>) => {
  try {
    const usersApi = await buildUsersApiWithToken();
    const { data: user } = await usersApi.usersMyself();

    const data = await getMyAuthorizationWithToken();

    callback({
      type: "STATUS_LOADED",
      is2FAEnabled: data.twoFactorAuthEnabled ?? false,
      userId: user.id!,
    });
  } catch (e) {
    callback({
      type: "ERROR",
      message: i18next.t("settings.twoFA.messages.error"),
    });
  }
};

export const fetch2FAStatus =
  (
    _context: Settings2FAContext,
    _event: Settings2FAEvent
  ): InvokeCallback<Settings2FAEvent, Settings2FAEvent> =>
  (callback) => {
    queryApi(callback);
  };
